import React from 'react'

import { MessagePanel, FadeIn, Label } from '@pb/components'

import styles from './FailedOrdersNotice.scss'

const FailedOrdersNotice: React.FC = () => (
  <FadeIn className={styles.container}>
    <MessagePanel title={<Label copyKey="hub.custumer.rewards.los.error" />} />
  </FadeIn>
)

export default FailedOrdersNotice
